import { capitalize } from 'lodash';
import { Icon } from '@timeedit/ui-components';
import { message as antdMessage } from '@timeedit/ui-components/antd';
import type { MessageInstance } from '@timeedit/ui-components/antd/message/interface';

type Message = Pick<
  typeof antdMessage,
  'info' | 'success' | 'warning' | 'error'
>;
type Content = Parameters<Message['info']>[0];
type MessageType = 'info' | 'success' | 'warning' | 'error';

let messageApi: MessageInstance | null = null;

export const registerMessageApi = (api: MessageInstance) => {
  messageApi = api;
};

// Fallback to static message if API is not yet registered
const getMessageApi = () => messageApi || antdMessage;

antdMessage.config({
  top: 50,
  duration: 3,
  maxCount: 3,
});

export const message: Message = {
  info: (content, duration, onClose) =>
    getMessageApi().info(handleContent(content, 'info'), duration, onClose),
  success: (content, duration, onClose) =>
    getMessageApi().success(
      handleContent(content, 'success'),
      duration,
      onClose
    ),
  warning: (content, duration, onClose) =>
    getMessageApi().warning(
      handleContent(content, 'warning'),
      duration,
      onClose
    ),
  error: (content, duration, onClose) =>
    getMessageApi().error(handleContent(content, 'error'), duration, onClose),
};

const handleContent = (content: Content, type: MessageType): Content => {
  const icon = (
    <Icon id={capitalize(type)} alt={`${type} icon`} className="te-text-lg" />
  );

  if (typeof content === 'string') {
    return {
      content,
      icon,
    };
  }

  if (typeof content === 'object' && content !== null && 'content' in content) {
    return {
      icon,
      ...content,
    };
  }

  return content;
};
